<template>
    <div class="updatSeting">
      <el-row>
        <div class="model-header setting">
          <h2>Thiết lập danh mục hồ sơ cần bổ sung của học viên</h2>
          <el-button @click="logModel.dialogVisibleLog = true" size="small" type="info" class="btn-create">Xem log
          </el-button>
        </div>
      </el-row>
      <el-row :gutter="10">
        <div class="model-content">
          <el-row :gutter="20">
            <el-col :span="10">
                <div v-for="(item) in modelData" :key="item.key">
                    <div class="line">
                        <el-input v-model="item.doct_name" class="input-seach"></el-input>
                        <el-button @click.prevent="removeItem(item)" size="small">Xóa</el-button>
                    </div>
                </div>
                <el-button class="huhu" type="default" size="mini" @click="addItem()">Thêm danh mục</el-button>
            </el-col>
          </el-row>
        </div>
      </el-row>
      <div style="padding-top: 20px">
        <el-button
          :disable="!canSubmit"
          :loading="!canSubmit"
          type="warning"
          size="small"
          @click="updateModelData()">Cập nhật
        </el-button>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :title="'Lịch sử thay đổi'"
        :visible.sync="logModel.dialogVisibleLog"
        width="45%">
        <div class="log-class-user" v-if="logModel.logs">
          <div
            class="item"
            :key="index_1"
            v-for="(item, index_1) in logModel.logs">
            <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> đã cập nhật cấu hình
            <div>
              <span class="time">{{ item.time }}</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="logModel.dialogVisibleLog = false" size="small">Cancel</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import axios from 'axios'
  import {head} from 'lodash'
  import {mapActions, mapGetters} from 'vuex'
  import tinymce from 'vue-tinymce-editor'
  import ls from 'local-storage'
  
  export default {
    name: 'ConfigStudentRequiredDoct',
    components: {
      tinymce
    },
    metaInfo () {
      return {
        title: 'Thiết lập danh mục hồ sơ cần bổ sung của học viên'
      }
    },
    data () {
      return {
        canSubmit: true,
        logModel: {
          dialogVisibleLog: false,
          activeName: 'first',
          logs: {}
        },
        tinymce: {
          toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
        },
        modelData: {},
        modelData_ID: 0,
      }
    },
    computed: {
      ...mapGetters('account', ['accountInfo'])
    },
    mounted () {
      this.configBreadcrumb()
      this.fetchModelData()
    },
    methods: {
      // Lấy action từ Vuex
      ...mapActions(['setBreadcrumb']),
      // Cấu hình Breadcrumb
      configBreadcrumb () {
        let breadcrumb = [
          {name: 'home-index', text: 'Trang chủ'},
          {name: 'configs-home', text: 'Config Home'}
        ]
        this.setBreadcrumb(breadcrumb)
      },
      // Nút back lại trang Index
      backModel () {
        this.$router.push({name: 'home-index'})
      },
      // Tải dữ liệu Model xuống
      fetchModelData () {
        this.canSubmit = false
        axios.get('configs/student-required-document').then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.modelData = response.data.value
              if (!this.modelData) {
                this.modelData = [];
              }
              this.modelData_ID = response.data.id
              this.logModel.logs = response.data.logs
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      updateModelData (formName) {
        this.canSubmit = false
        let data = {
          'value': this.modelData,
          'key': 'student-required-document'
        }
        axios.put('configs/' + this.modelData_ID, data).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Cập nhật thành công',
                type: 'success'
              })
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      addItem () {
        this.modelData.push({
          'doct_id': Math.floor(Math.random() * 100000) + 1,
          'doct_name': ''
        })
      },
      removeItem (item) {
        var index = this.modelData.indexOf(item)
        if (index !== -1) {
          this.modelData.splice(index, 1)
        }
      }

    }
  }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style type="text/css" scoped>
  .model-content {
    padding-top: 15px;
  }
  
  .huhu {
    margin-top: 10px;
  }
  
  .line {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .line input {
    margin-right: 10px;
  }
  
  .image-preview {
    height: 50px;
    width: 50px;
    margin-right: 10px;
  }
  </style>
  <style type="text/css">
  .updatSeting .course-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }
  
  .course-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  
  .updatSeting .course-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 100px;
    line-height: 100px !important;
    text-align: center;
  }
  
  .updatSeting .courseSettig {
    width: 100px;
    height: 100px;
  }
  
  .courseSetting {
    display: block;
    width: 100%;
    height: auto;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/config-home/StudentRequiredDoct.vue